<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div style="height: 150px" class="top_bg">
      <headers pageType="appointmentIndex"></headers>
      <div class="position">
        <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>预约服务</span></p></div>
      </div>
    </div>
    <div class="fixed">
      <fixedDiv></fixedDiv>
    </div>
    <div class="serverqh wraper" style="margin-top: 10px;">
      <h2 class="tit"></h2>
      <ul style="display: flex;justify-content: space-between">
        <li @click="showClause('servicesAppointmentMarry','marry','结婚登记预约')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>结婚登记预约</p></a></li>
        <li @click="showClause('servicesAppointmentMarry','divorce','离婚登记预约')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>离婚登记预约</p></a></li>
        <li @click="showClause('servicesAppointmentMarry','new_marry_card','补领结婚证预约')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>补领结婚证预约</p></a></li>
        <li @click="showClause('servicesAppointmentMarry','new_divorce_card','补领离婚证预约')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>补领离婚证预约</p></a></li>
        <li @click="showClause('funeralAppointment','funeral','殡葬业务预约')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>殡葬业务预约</p></a></li>
        <li @click="showClause('tombSweepingAppointment','sweep','扫墓预约')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>扫墓预约</p></a></li>
        <li @click="showClause('helpSweepingAppointment','help_sweep','代为扫墓预约')"   class="noticeIndex_li" ><a href="javascript:void(0)" ><p>代为扫墓预约</p></a></li>
      </ul>
    </div>
    <div style="line-height: 35px;">
      <el-dialog @close="close(1)" :visible.sync="clauseShow" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">{{this.cTitle}}</div>
        <div v-if="cContent!==''" style="font-size: 14px;margin-left: 40px;margin-right: 35px;"><p v-html="this.cContent">{{this.cContent}}</p></div>
        <div v-else>
          <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
            <div><img src="../../static/images/empty-image-default.png" style="width: 300px;" /></div>
            <div>暂无数据</div>
          </div>
        </div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button  type="primary" @click="clauseClose" >我已详细阅读</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="clear"></div>


    <footers></footers>
  </div>

</template>

<script>
  import headers from "../components/Headers";
  import fixedDiv from "../components/FixedDiv";
  import footers from "../components/Footer";
  export default {
    name: "public-index",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      return {
        clauseShow:false,
        condition:'',
        url:'',
        cContent:'',
        cTitle:'',
        service_code:'',
        title:'',
        active: 'publicIndex',
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        activeName: 'zcwj',
        infoData:{},
        tzgg:[],
        zcwj:[],
        orgTypeList:[],
        SocialTypeList:[],
        yggs:[],
      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      }
    },
    mounted(){

    },
    created(){
      this.getOrgServiceType();
      this.getSocialServiceType();
    },
    methods: {
      getSocialServiceType(){
        var tt=this;
        this.$https.post("api/socialService/getSocialServiceType.do",{},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            tt.SocialTypeList=response.data.data
          }
        })
      },
      getOrgServiceType(){
        var tt=this;
        this.$https.post("api/orgservice/getOrgServiceType.do",{},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            tt.orgTypeList=response.data.data
          }
        })
      },
      handleClick(tab, event) {
        //异步获取数据
        this.initNews(tab.name);
      },
      showClause(url,service_code,title){
        this.url=url;
        this.service_code=service_code;
        this.title=title;
        this.clauseShow=true;
      },
      goto(){
        this.urlTo('helpSweepingAppointment',{service_code:'help_sweep',title:'代为扫墓预约'})
      },
      clauseClose(){
        this.clauseShow=false;
        this.urlTo(this.url,{service_code:this.service_code,title:this.title})
      },
      close(value){
        if (value==1){

          this.urlTo("appointmentIndex")
        }else {

        }

      },

      onChange(index) {
        //  Notify({ type: 'primary', message: index+"_"});
        this.$router.push(index);
      },
      gotoReg(){
        this.$router.push("/peopleReg");

      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      urlTo2(url,params){
        this.$message({
          message: '暂未开放',
          type: 'warning'
        });
        // this.$router.push({path:url,query:params||{}});
      }

    }
  }



</script>
<style>
  .info .el-tabs__item.is-active {
    background: url(../../static/images/tit_bg_on.png) repeat-x bottom left;
    color: #2c62ec;
    font-weight: bold;
  }
  .info .el-tabs__item  {
    width:100px;
    text-align: center;
    font-size: 18px;
    padding: 0 0px;
    margin-left: 20px;
    line-height: 65px;
    height: 65px;
  }
  .info .el-tabs__active-bar{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AppointmentIndex.vue